import { z } from 'zod'

/**
 * This is the canonical way to express zod date times for Omnea
 */
export const DateTimeSchema = z.iso.datetime({ offset: true })
